import React from 'react';
import { connect } from 'react-redux';
import { ValidMe } from '../../../../businessLogic/validation.js';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { updateGroupForm } from '../../../../actions/group.js';
import { clone } from '../../../../reducers/helper.js';

@connect(mapStateToProps)
export default class CenterPanelCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      organisations: props.organisations,
      videoCallQualityProfiles: props.videoCallQualityProfiles,
      defaultVideoCallQuality: props.defaultVideoCallQuality,
      groupForm: props.groupForm,
      postCallSurveOptions: APP.LANGUAGE.PostCallSurvey.Options,
      displayPostCallUrl: false,
      displayProviderUrl: false,
      displayCallerGuestUrl: false,
    };
  }

  groupUpdated = (property, value) => {
    let val = value;
    var cloneGroup = clone(this.state.groupForm);
    property.map((option, i) => {
      cloneGroup[option] = value[i];
    }, this);
    return cloneGroup;
  };

  organisationSelectedChanged = (option) => {
    if (option) {
      if (option.name) {
        var parentOrganisation = option.name + ' (' + option.abbreviatedName + ')';
        var groupForm = this.groupUpdated(
          ['organisationName', 'organisationNetworkId'],
          [parentOrganisation, option.id]
        );
        groupForm.purgeCallerDetails = option.purgeCallerDetailsEndOfCall ? true : false; //also getting the default state
        this.props.dispatch(updateGroupForm(groupForm));
      }
    }
  };

  callQualitySelectedChanged = (option) => {
    if (option && option.id) {
      this.props.dispatch(updateGroupForm(this.groupUpdated(['videoCallQualityId'], [option.id])));
    }
  };

  postCallSurveSelectedChanged = (option) => {
    if (option && option.Id != undefined) {
      this.hideDisplaySurveyOptions(option.Id);
      //we will have view also so we may have to set the name
      this.props.dispatch(updateGroupForm(this.groupUpdated(['postCallOptionId'], [option.Id])));
    }
  };

  hideDisplaySurveyOptions = (id) => {
    if (id == 1) {
      this.setState({
        displayPostCallUrl: true,
        displayProviderUrl: false,
        displayCallerGuestUrl: false,
      });
    } else if (id == 2) {
      this.setState({
        displayPostCallUrl: false,
        displayProviderUrl: true,
        displayCallerGuestUrl: true,
      });
    } else {
      //either option.id==0 or anyother
      this.setState({
        displayPostCallUrl: false,
        displayProviderUrl: false,
        displayCallerGuestUrl: false,
      });
    }
  };

  purgeCallerChanged = () => {
    this.props.dispatch(
      updateGroupForm(this.groupUpdated(['purgeCallerDetails'], [!this.props.groupForm.purgeCallerDetails]))
    );
  };

  groupNameChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['name'], [value])));
  };
  groupEmailChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['email'], [value])));
  };

  postCallUrlChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['postCallUrl'], [value])));
  };

  providerUrlChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['providerUrl'], [value])));
  };

  callerGuestUrlChanged = (value) => {
    this.props.dispatch(updateGroupForm(this.groupUpdated(['callerGuestUrl'], [value])));
  };

  UNSAFE_componentWillReceiveProps = (props) => {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA

    this.hideDisplaySurveyOptions(props.groupForm.postCallOptionId); //setting display option based on the call back url option
    if (this.props.groupForm && this.props.groupForm.videoCallQualityId == 0 && this.props.defaultVideoCallQuality) {
      //the callQualityId is 0/empty and there is a defaultVideoCall Quality Id
      var videoCallQuality = this.props.videoCallQualityProfiles.find(
        (x) => x.id == this.props.defaultVideoCallQuality
      );
      //if there is a videoCallQuality object found against the default Id
      if (videoCallQuality) {
        var copy = clone(props.groupForm);
        copy.videoCallQualityId = videoCallQuality.id; //setting the groupForm videoCallQualityId to default value;
        if (!copy.email) copy.email = this.props.groupNotificationEmail;
        this.props.dispatch(updateGroupForm(copy));
      }
    }

    this.setState({
      organisations: props.organisations,
      groupForm: props.groupForm,
      videoCallQualityProfiles: props.videoCallQualityProfiles,
      defaultVideoCallQuality: props.defaultVideoCallQuality,
    });
  };

  render() {
    let serverValueFromServer = 0;
    let dropdownDefault = '';
    let elementsToRender = '';
    let checkBoxClass = 'ui checkbox mrbm color-black';
    if (this.props.groupForm.purgeCallerDetails) {
      checkBoxClass = 'checked ui checkbox mrbm color-black';
    }

    if (this.props.modalVisible) {
      elementsToRender = (
        <div className="ui form">
          <div className="mrbl">
            <h4 className="mrbl">{APP.LANGUAGE.CreateUpdateGroup.BasicDetailsHeading}</h4>
          </div>
          <ValidMe
            validmefor="length@3-48"
            validmemessage={APP.LANGUAGE.Errors.GroupValidNameLength}
            group="createGroupForm"
          >
            <Txt
              tabIndex="1"
              focusme="true"
              value={this.state.groupForm.name}
              placeholder={APP.LANGUAGE.CreateUpdateGroup.NamePlaceholder}
              noTitle
              onChange={this.groupNameChanged}
            />
          </ValidMe>
          <ValidMe
            validmefor="dropdown"
            group="createGroupForm"
            defaulttext={APP.LANGUAGE.CreateUpdateGroup.OrganisationPlaceHolder}
            validmemessage={APP.LANGUAGE.Errors.CreateGroupNonSelectedOrganisationError}
          >
            <Txt
              dropdown
              tabIndex="2"
              placeholder={APP.LANGUAGE.CreateUpdateGroup.OrganisationPlaceHolder}
              text={APP.LANGUAGE.CreateUpdateGroup.OrganisationPlaceHolder}
              value={this.state.groupForm.parentGroupName}
              selectedItemPlaceholder={APP.LANGUAGE.CreateUpdateGroup.SelectedOrganisationPlaceHolder}
              fields={'name,abbreviatedName'}
              options={this.state.organisations}
              onChange={this.organisationSelectedChanged}
            />
          </ValidMe>

          <ValidMe validmefor="email" validmemessage={APP.LANGUAGE.Errors.InvalidEmail} group="createGroupForm">
            <Txt
              tabIndex="4"
              value={this.state.groupForm.email}
              placeholder={APP.LANGUAGE.CreateUpdateGroup.EmailPlaceholder}
              noTitle
              onChange={this.groupEmailChanged}
            />
          </ValidMe>
          <div className="mrbl">
            <h4 className="mrbl">{APP.LANGUAGE.CreateUpdateGroup.MeetingRoomsHeading}</h4>
          </div>
          <ValidMe
            validmefor="dropdown"
            group="createGroupForm"
            defaulttext={APP.LANGUAGE.CreateUpdateGroup.CallQualityPlaceHolder}
            validmemessage={APP.LANGUAGE.Errors.CreateGroupNonSelectedCallQualityError}
          >
            <Txt
              dropdown
              tabIndex="5"
              placeholder={APP.LANGUAGE.CreateUpdateGroup.CallQualityPlaceHolder}
              text={APP.LANGUAGE.CreateUpdateGroup.CallQualityPlaceHolder + ' '}
              selectedItemPlaceholder={APP.LANGUAGE.CreateUpdateGroup.SelectedCallQualityPlaceHolder}
              value={
                this.props.videoCallQualityProfiles.length > 0
                  ? this.props.videoCallQualityProfiles.find((x) => x.id == this.props.defaultVideoCallQuality)
                      .description
                  : APP.LANGUAGE.CreateUpdateGroup.CallQualityPlaceHolder
              }
              fields={'description'}
              options={this.state.videoCallQualityProfiles}
              onChange={this.callQualitySelectedChanged}
            />
          </ValidMe>

          <ValidMe
            validmefor="dropdown"
            group="createGroupForm"
            defaulttext={APP.LANGUAGE.CreateUpdateGroup.PostCallSurveyPlaceholder}
            validmemessage={APP.LANGUAGE.Errors.CreateGroupNonSelectedSurveyError}
          >
            <Txt
              dropdown
              tabIndex="6"
              text={APP.LANGUAGE.CreateUpdateGroup.PostCallSurveyLabel + ' '}
              onChange={this.postCallSurveSelectedChanged}
              placeholder={APP.LANGUAGE.CreateUpdateGroup.PostCallSurveyPlaceholder}
              selectedItemPlaceholder={APP.LANGUAGE.CreateUpdateGroup.SelectedSurveyOptionPlaceHolder}
              value={this.state.postCallSurveOptions.find((x) => x.Id == serverValueFromServer).Name}
              fields={'Name'}
              options={this.state.postCallSurveOptions}
            />
          </ValidMe>
          <ValidMe validmefor="urlOptional" validmemessage={APP.LANGUAGE.Errors.InvalidUrl} group="createGroupForm">
            <Txt
              tabIndex="7"
              show={this.state.displayPostCallUrl}
              value={this.state.groupForm.postCallUrl}
              placeholder={APP.LANGUAGE.PostCallSurvey.SameInformationSurvePageLabelPlaceHolder}
              titlePlaceholder={APP.LANGUAGE.PostCallSurvey.SameInformationSurvePageLabel}
              noTitle
              onChange={this.postCallUrlChanged}
            />
          </ValidMe>
          <ValidMe validmefor="urlOptional" validmemessage={APP.LANGUAGE.Errors.InvalidUrl} group="createGroupForm">
            <Txt
              tabIndex="7"
              show={this.state.displayProviderUrl}
              value={this.state.groupForm.providerUrl}
              placeholder={APP.LANGUAGE.PostCallSurvey.DifferentSurveyGroupMemberUrlPlaceHolder}
              titlePlaceholder={APP.LANGUAGE.PostCallSurvey.DifferentSurveyGroupMemberUrlLabel}
              noTitle
              onChange={this.providerUrlChanged}
            />
          </ValidMe>
          <ValidMe validmefor="urlOptional" validmemessage={APP.LANGUAGE.Errors.InvalidUrl} group="createGroupForm">
            <Txt
              tabIndex="8"
              show={this.state.displayCallerGuestUrl}
              value={this.state.groupForm.callerGuestUrl}
              titlePlaceholder={APP.LANGUAGE.PostCallSurvey.DifferentSurveyOtherParticipantLabel}
              placeholder={APP.LANGUAGE.PostCallSurvey.DifferentSurveyOtherParticipantPlaceHolder}
              noTitle
              onChange={this.callerGuestUrlChanged}
            />
          </ValidMe>

          <Txt
            checkbox
            classes={checkBoxClass}
            show={this.props.isPortalAdmin}
            tabIndex="9"
            text={APP.LANGUAGE.CreateUpdateGroup.PurgeCallerPlaceholder}
            checked={this.props.groupForm.purgeCallerDetails}
            onChange={this.purgeCallerChanged}
          />

          <div data-show={!this.props.isPortalAdmin && this.props.groupForm.organisationNetworkId > 0}>
            <label className="color-black" data-show={this.props.groupForm.purgeCallerDetails}>
              {APP.LANGUAGE.ViewGroup.PurgeCallDetailsLabel}
            </label>
            <label className="color-black" data-show={!this.props.groupForm.purgeCallerDetails}>
              {APP.LANGUAGE.ViewGroup.DontPurgeCallDetailsLabel}
            </label>
          </div>
        </div>
      );
    }

    return <span>{elementsToRender}</span>;
  }
}

function mapStateToProps(state) {
  return {
    organisations: state.organisationsReducer.groupOrganisations,
    groupForm: state.groupsReducer.groupForm,
    videoCallQualityProfiles: state.portalSettingReducer.portalSetting.videoCallQualityProfiles,
    defaultVideoCallQuality: state.portalSettingReducer.portalSetting.defaultVideoCallQuality,
    isPortalAdmin: state.usersReducer.userProfile && state.usersReducer.userProfile.isPortalAdmin,
    groupNotificationEmail: state.usersReducer.userProfile.email,
    userProfile: state.usersReducer.userProfile,
    modalVisible: state.modalReducer.modalVisible,
  };
}
